<template>
  <div class="templates">
    <Modal v-model="addTemplateModal" width="600" scrollable title="添加模板">
      <i-form :model="addTemplateForm" ref="addTemplateForm" :rules="addTemplateRule" :label-width="75">
        <FormItem label="模板组" prop="group">
          <i-select v-model="addTemplateForm.group" :transfer="true">
            <i-option v-for="item in tmpGroupList" :value="item.id" :key="item.id" :label="item.name"></i-option>
          </i-select>
        </FormItem>
        <FormItem label="模板名称" prop="name">
          <Input v-model="addTemplateForm.name" :maxlength="48" />
        </FormItem>
        <FormItem label="置顶" prop="top">
          <i-switch v-model="addTemplateForm.top">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
      </i-form>
      <div slot="footer">
        <Button type="primary" @click="addTemplateModalOk" :loading="addTemplateSubmitting">提交</Button>
        <Button @click="addTemplateModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Modal v-model="changeMyTemplateModal" width="600" scrollable :title="changeMyTemplateModalTitle">
      <i-form :model="changeMyTemplateForm" ref="changeMyTemplateForm" :rules="changeMyTemplateRule" :label-width="75">
        <FormItem label="模板名称" prop="name">
          <Input v-model="changeMyTemplateForm.name" :maxlength="48" />
        </FormItem>
        <FormItem label="置顶" prop="top">
          <i-switch v-model="changeMyTemplateForm.top">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
      </i-form>
      <div slot="footer">
        <Button type="primary" @click="changeMyTemplateModalOk" :loading="changeMyTemplateSubmitting">提交</Button>
        <Button @click="changeMyTemplateModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Modal footer-hide v-model="chartScreenModal" width="90%">
      <div class="title" :style="{textAlign: 'center'}"><b><span id="chartScreenId_title" :style="{fontSize: '16px'}"></span></b></div>
      <Form :model="graphFilter" style="margin: 20px 0 0 0;" ref="graphFilter" label-position="left" inline>
        <FormItem>
          <radio-group v-model="graphFilter.last" type="button" size="small" @on-change="lastTimeChange">
            <radio label=3600>1小时</radio>
            <radio label=21600>6小时</radio>
            <radio label=43200>12小时</radio>
            <radio label=86400>1天</radio>
            <radio label=259200>3天</radio>
            <radio label=604800>7天</radio>
            <radio label=2592000>1月</radio>
          </radio-group>
        </FormItem>
        <FormItem>
          <DatePicker
            v-model="customTime"
            type="datetimerange"
            style="width: 250px; margin-left: 5px"
            format="yyyy-MM-dd HH:mm"
            @on-ok="customTimeChange"
            @on-clear="customTimeClear"
            placeholder="自定义时间"></DatePicker>
        </FormItem>
        <!--<FormItem>-->
        <!--<Select v-model="graphFilter.angle" placeholder="Endpoint视角" style="width: 120px;" :transfer="true" @on-change="getGraphData(graphFilter, 'chartScreenId')">-->
        <!--<Option v-for="item in angle_list" :value="item.value" :key="item.value" :label="item.label"></Option>-->
        <!--</Select>-->
        <!--</FormItem>-->
        <FormItem>
          <Select v-model="graphFilter.cf" placeholder="平均值" style="width: 100px;" :transfer="true" @on-change="getGraphData(graphFilter, 'chartScreenId')">
            <Option v-for="item in cf_list" :value="item.value" :key="item.value" :label="item.label"></Option>
          </Select>
        </FormItem>
        <FormItem label="求和" :label-width="45">
          <i-switch v-model="graphFilter.sum" @on-change="getGraphData(graphFilter, 'chartScreenId')">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="只求和" :label-width="60">
          <i-switch v-model="graphFilter.sumonly" @on-change="getGraphData(graphFilter, 'chartScreenId')">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem :style="{float: 'right'}">
          <Button @click="saveTmpGraph" type="primary" style="margin-left: 5px;">保存</Button>
        </FormItem>
      </Form>
      <div :style="{height: '500px'}" id="chartScreenId"></div>
    </Modal>
    <Modal :title="tmpGroupModalTitle" v-model="tmpGroupModal" @on-cancel="tmpGroupFormReset">
      <Form ref="tmpGroupForm" :model="tmpGroupForm" :rules="tmpGroupRule" :label-width="80">
        <FormItem label="分组名称" prop="name">
          <Input v-model="tmpGroupForm.name" :maxlength="48" />
        </FormItem>
        <FormItem label="置顶" prop="top">
          <i-switch v-model="tmpGroupForm.top">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="默认展开" prop="default_open">
          <i-switch v-model="tmpGroupForm.default_open">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="可读用户">
          <Select v-model="tmpGroupForm.only_read_user" multiple>
            <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="tmpGroupSubmit" :loading="tmpGroupSubmitting">提交</Button>
        <Button @click="tmpGroupModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Modal title="模板组合并" v-model="tmpGroupMergeModal" @on-cancel="tmpGroupMergeFormReset">
      <Form ref="tmpGroupMergeForm" :model="tmpGroupMergeForm" :rules="tmpGroupMergeRule" :label-width="80">
        <FormItem label="源" prop="source">
          <Select v-model="tmpGroupMergeForm.source" style="width: 300px">
            <Option v-for="item in tmpGroupList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="目标" prop="target">
          <Select v-model="tmpGroupMergeForm.target" style="width: 300px">
            <Option v-for="item in tmpGroupList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="tmpGroupMergeSubmit" :loading="tmpGroupMergeSubmitting">提交</Button>
        <Button @click="tmpGroupMergeModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Modal title="模板组分发" v-model="tmpGroupAssignModal" @on-cancel="tmpGroupAssignFormReset">
      <Form ref="tmpGroupAssignForm" :model="tmpGroupAssignForm" :rules="tmpGroupAssignRule" :label-width="80">
        <FormItem label="模板组" prop="group">
          <Select v-model="tmpGroupAssignForm.group" style="width: 300px">
            <Option v-for="item in tmpGroupList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="目标用户" prop="user">
          <Select v-model="tmpGroupAssignForm.user" filterable>
            <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="tmpGroupAssignSubmit" :loading="tmpGroupAssignSubmitting">提交</Button>
        <Button @click="tmpGroupAssignModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Modal :title="moveTmpTitle" v-model="moveTmpModal" @on-cancel="moveTmpFormReset">
      <Form ref="moveTmpForm" :model="moveTmpForm" :rules="moveTmpRule" :label-width="80">
        <FormItem label="移动至" prop="group">
          <Select v-model="moveTmpForm.group" style="width: 300px">
            <Option v-for="item in tmpGroupList" :value="item.id" :key="item.id" :disabled="moveTmpCurrentGroup === item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="moveTmpSubmit" :loading="moveTmpSubmitting">提交</Button>
        <Button @click="moveTmpModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <div>
      <Layout>
        <Sider v-show="!tmpListShow" :style="{background: '#F5F7F9', marginRight: '10px', minWidth: '30px', width: '30px', maxWidth: '30px'}">
          <a style="float: left; color: #5c6b77;" v-on:click="tmpListShow = true; refresh()">
            <font-awesome-icon icon="indent" style="font-size: 20px; line-height: 32px; height: 32px;" />
          </a>
        </Sider>
        <Sider v-show="tmpListShow" :style="{background: '#F5F7F9', marginRight: '10px', width: '300px', minWidth: '250px', maxWidth: '250px'}">
          <Alert v-if="tmpGroupError" show-icon type="error">获取模板失败</Alert>
          <div v-else>
            <div style="margin-bottom: 5px">
              <span><b>主题：</b></span>
              <Select v-model="currentTheme" @on-change="saveMonitorConfig" style="width:100px; margin: 0 5px">
                <Option v-for="item in themeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
              <Button icon="md-refresh" type="primary" @click="refresh" :loading="refreshLoading">刷新</Button>
              <a style="float: right; color: #5c6b77;" v-on:click="tmpListShow = false; refresh()">
                <font-awesome-icon icon="outdent" style="font-size: 20px; line-height: 32px; height: 32px;" />
              </a>
            </div>
            <Button type="text" size="small" icon="md-add" style="font-size: 12px;" @click="tmpGroupModal = true">添加分组</Button>
            <Collapse :value="tmpGroupCollapse" id="tmp-group-collapse">
              <Panel v-for="item in tmpGroupList" :name="item.id + item.name" :key="item.id">
                <span style="float: left; overflow: hidden; text-overflow:ellipsis; white-space: nowrap; width: 150px;">
                  <Tooltip max-width="150" :content="item.name" placement="bottom-start">
                    <span>{{ item.name }}</span>
                  </Tooltip>
                </span>
                <Tooltip v-if="$store.state.user.userId !== item.user" :content="'所属用户：' + item.user_full_name" placement="bottom-start" style="float: right;">
                  <Tag color="geekblue">只读</Tag>
                </Tooltip>
                <Dropdown v-else style="float: right; margin-right: 5px" @on-click="v=>{ tmpGroupToolsClick(v, item)}" transfer>
                  <a href="javascript:void(0)" style="color:#666">
                    <Icon type="md-more" size="18"></Icon>
                  </a>
                  <DropdownMenu slot="list">
                    <DropdownItem name="top" v-if="!item.top">置顶</DropdownItem>
                    <DropdownItem name="cancel_top" v-if="item.top">取消置顶</DropdownItem>
                    <DropdownItem name="edit">编辑</DropdownItem>
                    <DropdownItem name="add">创建模板</DropdownItem>
                    <DropdownItem name="merge">合并</DropdownItem>
                    <DropdownItem name="assign">分发</DropdownItem>
                    <DropdownItem name="delete" style="color: red">删除</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <div slot="content" class="cu-content">
                  <div v-for="tmp_item in item.tmp_group_related" :key="tmp_item.id" style="height: 30px">
                    <a :class="{'tmp-item': true, 'tmp-item-active': tmp_item.id === formItem.myTemplate }" v-on:click="clickTmp(tmp_item.id)">
                    <span style="overflow: hidden; text-overflow:ellipsis; white-space:nowrap; display: inline-block; width: 180px">
                      <Tooltip max-width="180" :content="tmp_item.name" placement="bottom-start">
                        {{ tmp_item.name }}
                      </Tooltip>
                    </span>
                      <Dropdown v-if="$store.state.user.userId === tmp_item.user" style="float: right; margin-right: 5px; width: 10px" @on-click="v=>{ tmpToolsClick(v, tmp_item)}" transfer>
                        <a href="javascript:void(0)" style="color:#666">
                          <Icon type="md-more" size="18"></Icon>
                        </a>
                        <DropdownMenu slot="list">
                          <DropdownItem name="top" v-if="!tmp_item.top">置顶</DropdownItem>
                          <DropdownItem name="cancel_top" v-if="tmp_item.top">取消置顶</DropdownItem>
                          <DropdownItem name="edit">编辑</DropdownItem>
                          <DropdownItem name="move">移动至</DropdownItem>
                          <DropdownItem name="delete" style="color: red">删除</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </a>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>
        </Sider>
        <Content>
          <Col>
            <Spin fix v-if="refreshLoading" style="height: 150px" :style="{backgroundColor: '#F5F7F9'}">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            </Spin>
            <Alert show-icon type="error" v-else-if="dataError">获取监控数据失败</Alert>
            <div id="monitor_card" v-else-if="data.length">
              <Row :gutter="16">
                <div v-for="item in data" v-bind:key="item.id">
                  <Col :xs="24" :sm="24" :md="24" :lg="12" :style="{marginBottom: '10px'}">
                    <Col span="24">
                      <Card>
                        <p slot="title">
                          <span :id="'graph_id_' + item.id + '_title'"></span>
                          <span :style="{float : 'right'}">
                          <Button type="text" @click="chartScreen(item)" size="small">
                            <Icon type="md-expand" size="16" />
                          </Button>
                          <Button type="text" @click="removeTmpGraph(item.id, item.tmp)" size="small">
                            <Icon type="ios-close-circle" size="16" />
                          </Button>
                        </span>
                        </p>
                        <div :id="'graph_id_' + item.id" style="width: 100%; height: 300px"></div>
                      </Card>
                    </Col>
                  </Col>
                </div>
              </Row>
            </div>
            <Alert show-icon v-else>当前模板未添加图表</Alert>
          </Col>
        </Content>
      </Layout>
    </div>
  </div>
</template>

<script>
import { getTmpGraph, getEndpointMonitorData, ChangePersonalTmp, getPersonalTmp,
  deletePersonalTmp, deleteTmpGraph, updateTmpGraph, getMonitorConfig, changeMonitorConfig, getPersonalTmpGroup,
  ChangePersonalTmpGroup, deletePersonalTmpGroup, personalTmpGroupMerge, personalTmpGroupAssign } from '@/api/monitor'
import { valueTranUnit } from '@/libs/tools'
import { GetALLUsers } from '@/api/user'
import echarts from './components/echarts-use.js'

let option = {
  title: {
    text: ''
  },
  grid: {
    x: 40,
    x2: 40,
    left: 60
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none'
      },
      dataView: {readOnly: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {}
    }
  },
  tooltip: {
    trigger: 'axis',
    formatter: function (params) {
      let str = '<div>' + params[0].axisValueLabel + '</div>'
      for (let i = 0; i < params.length; i++) {
        let value = params[i].data[1]
        let reValue = valueTranUnit(value, 1, '')
        str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
          '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
      }
      return str
    }
  },
  legend: {
    x: 'center',
    y: 'bottom',
    type: 'scroll',
    width: '90%',
    icon: 'rect',
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 15
  },
  xAxis: {
    type: 'time',
    splitLine: {
      show: true
    }
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true
    },
    axisLabel: {
      formatter: function (value) {
        return valueTranUnit(value, 0)
      }
    }
  },
  series: []
}

export default {
  name: 'templates',
  data () {
    return {
      currentTheme: 'dark',
      monitorTheme: 'dark',
      options: {},
      themeList: [
        {label: 'dark', value: 'dark'},
        {label: 'roma', value: 'roma'},
        {label: 'shine', value: 'shine'},
        {label: 'vintage', value: 'vintage'},
        {label: 'macarons', value: 'macarons'},
        {label: 'infographic', value: 'infographic'},
        {label: 'darkPro', value: 'darkPro'},
        {label: 'dark-line', value: 'dark-line'},
        {label: 'roma-line', value: 'roma-line'},
        {label: 'shine-line', value: 'shine-line'},
        {label: 'vintage-line', value: 'vintage-line'},
        {label: 'macarons-line', value: 'macarons-line'},
        {label: 'infographic-line', value: 'infographic-line'},
        {label: 'darkPro-line', value: 'darkPro-line'}
      ],
      myTemplateList: [],
      refreshLoading: false,
      formItem: {
        myTemplate: ''
      },
      changeMyTemplateModal: false,
      changeMyTemplateModalTitle: '修改模板',
      changeMyTemplateForm: {
        id: 0,
        name: '',
        top: false
      },
      changeMyTemplateRule: {
        name: [
          {required: true, message: '模板名称是必填的', trigger: 'blur'}
        ],
        top: [
          {required: true, type: 'boolean', message: '', trigger: 'change'}
        ]
      },
      changeMyTemplateSubmitting: false,
      data: [],
      noChat: false,
      dataError: false,
      chartScreenModal: false,
      chartScreenModalTitle: '',
      angle_list: [
        {
          value: 'endpoint',
          label: 'Endpoint视角'
        },
        {
          value: 'counter',
          label: 'Counter视角'
        },
        {
          value: 'merge',
          label: '组合视角'
        }
      ],
      cf_list: [
        {
          value: 'AVERAGE',
          label: '平均值'
        },
        {
          value: 'MAX',
          label: '最大值'
        },
        {
          value: 'MIN',
          label: '最小值'
        }
      ],
      graphFilter: {},
      customTime: '',
      // 添加模板
      addTemplateModal: false,
      addTemplateForm: {
        group: '',
        name: '',
        top: false
      },
      addTemplateRule: {
        group: [
          {required: true, type: 'number', message: '请选择分组', trigger: 'change'}
        ],
        name: [
          {required: true, message: '模板名称是必填的', trigger: 'blur'}
        ],
        top: [
          {required: true, type: 'boolean', message: '', trigger: 'change'}
        ]
      },
      addTemplateSubmitting: false,

      // 模板组
      tmpGroupCollapse: [],
      tmpListShow: true,
      tmpGroupModal: false,
      tmpGroupSubmitting: false,
      tmpGroupModalTitle: '添加模板组',
      tmpGroupForm: {
        id: 0,
        name: '',
        top: false,
        default_open: false,
        only_read_user: []
      },
      tmpGroupRule: {
        name: [
          {required: true, message: '分组名称是必填的', trigger: 'blur'}
        ],
        top: [
          {required: true, type: 'boolean', message: '', trigger: 'change'}
        ],
        default_open: [
          {required: true, type: 'boolean', message: '', trigger: 'change'}
        ]
      },
      tmpGroupList: [],
      userList: [],
      tmpGroupError: false,
      // 模板组合并
      tmpGroupMergeModal: false,
      tmpGroupMergeSubmitting: false,
      tmpGroupMergeForm: {
        source: '',
        target: ''
      },
      tmpGroupMergeRule: {
        source: [
          {required: true, validator: this.validMergeSourceForm, type: 'number', message: '', trigger: 'change'}
        ],
        target: [
          {required: true, validator: this.validMergeTargetForm, type: 'number', message: '', trigger: 'change'}
        ]
      },
      // 模板组分发
      tmpGroupAssignModal: false,
      tmpGroupAssignSubmitting: false,
      tmpGroupAssignForm: {
        group: '',
        user: ''
      },
      tmpGroupAssignRule: {
        group: [
          {required: true, type: 'number', message: '', trigger: 'change'}
        ],
        user: [
          {required: true, type: 'number', message: '', trigger: 'change'}
        ]
      },
      // 模板移动
      moveTmpTitle: '模板移动',
      moveTmpModal: false,
      moveTmpForm: {
        id: 0,
        group: ''
      },
      moveTmpRule: {
        group: [
          {required: true, type: 'number', message: '请选择目标模板组', trigger: 'change'}
        ]
      },
      moveTmpSubmitting: false,
      moveTmpCurrentGroup: ''
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getTheme()
      this.getAllUserData()
      this.getTmpGroupList(true)
    },
    drawGraph (value) {
      this.formItem.myTemplate = value
      let that = this
      that.data = []
      let chartEleScreen = $('#chartScreenId')
      chartEleScreen.html('')
      chartEleScreen.removeAttr('_echarts_instance_')
      let params = {
        'tmp': value
      }
      this.refreshLoading = true
      getTmpGraph(params).then(res => {
        this.refreshLoading = false
        let result = res.data
        this.data = result
        for (let v in result) {
          let graphId = 'graph_id_' + result[v].id
          that.getGraphData(result[v], graphId)
        }
        this.dataError = false
      }).catch(res => {
        this.dataError = true
        this.refreshLoading = false
        if (res.request) {
          that.$Notice.error({
            title: '获取模板信息失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getGraphData (params, graphId) {
      let that = this
      try {
        params.endpoints = params.endpoints.split('|')
        params.counters = params.counters.split('|')
      } catch (err) {}
      getEndpointMonitorData(params).then(res => {
        let result = res.data
        if (result.code === 200) {
          let data = result.data.series
          document.getElementById(graphId + '_title').innerHTML = result.data.title
          let dseries = []
          let haveArea = false
          let monitorTheme = this.monitorTheme
          if (monitorTheme.endsWith('-line')) {
            monitorTheme = monitorTheme.split('-line')[0]
          } else {
            haveArea = true
          }
          for (let v in data) {
            let dSeriesConfig = {
              name: data[v].name,
              data: data[v].data,
              type: 'line',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1
                  }
                }
              }
            }
            if (haveArea) {
              dSeriesConfig.areaStyle = {
                opacity: 0.2
              }
            }
            dseries.push(dSeriesConfig)
          }
          option.series = dseries
          let graphLine = echarts.init(document.getElementById(graphId), monitorTheme)
          window.addEventListener('resize', function () {
            graphLine.resize()
          })
          graphLine.clear()
          graphLine.setOption(option, true)
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！',
            desc: result.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取监控数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          that.$Notice.error({
            title: '获取监控数据失败'
          })
        }
      })
    },
    changeMyTemplateModalOk () {
      let that = this
      that.changeMyTemplateSubmitting = true
      ChangePersonalTmp(that.changeMyTemplateForm, that.changeMyTemplateForm.id).then(res => {
        that.changeMyTemplateSubmitting = false
        that.$Notice.success({
          title: '操作成功！'
        })
        this.getTmpGroupList()
        that.changeMyTemplateModal = false
        that.changeMyTemplateForm.id = 0
        that.changeMyTemplateForm.name = ''
        that.changeMyTemplateForm.top = false
      }).catch(res => {
        that.changeMyTemplateSubmitting = false
        if (res.request) {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    changeMyTemplateModalShow (id) {
      let that = this
      getPersonalTmp(id).then(res => {
        let result = res.data
        that.changeMyTemplateModalTitle = '修改模板「' + result.name + '」'
        that.changeMyTemplateForm.id = result.id
        that.changeMyTemplateForm.name = result.name
        that.changeMyTemplateForm.top = result.top
        that.changeMyTemplateModal = true
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取当前模板信息失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    removeTmp (tmp) {
      let that = this
      that.$Modal.confirm({
        title: '删除',
        content: '确定要删除模板「' + tmp.name + '」吗?',
        onOk: () => {
          deletePersonalTmp(tmp.id).then(res => {
            that.$Notice.success({
              title: '操作成功！'
            })
            that.getTmpGroupList(true)
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    removeTmpGraph (id, tmpId) {
      let that = this
      that.$Modal.confirm({
        title: '移除',
        content: '确定要移除当前监控图吗?',
        onOk: () => {
          deleteTmpGraph(id).then(res => {
            that.$Notice.success({
              title: '操作成功！'
            })
            that.getTmpGroupList(false)
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    chartScreen (data) {
      this.chartScreenModal = true
      this.graphFilter = data
      this.graphFilter.last = data.last + ''
      this.getGraphData(data, 'chartScreenId')
    },
    saveTmpGraph () {
      if (!this.graphFilter.last) {
        this.$Notice.error({title: '加入模板不能选择自定义时间！'})
        return false
      }
      updateTmpGraph(this.graphFilter, this.graphFilter.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.chartScreenModal = false
        this.drawGraph(this.formItem.myTemplate)
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getTheme () {
      getMonitorConfig().then(res => {
        let result = res.data
        if (result.code === 200) {
          this.monitorTheme = result.data.theme
          this.currentTheme = result.data.theme
        }
      })
    },
    saveMonitorConfig (theme) {
      if (this.monitorTheme === theme) {
        return false
      }
      this.monitorTheme = theme
      let reqData = {'theme': theme}
      changeMonitorConfig(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.drawGraph(this.formItem.myTemplate)
        }
      })
    },
    lastTimeChange () {
      this.customTime = ''
      this.graphFilter.start = ''
      this.graphFilter.end = ''
      this.getGraphData(this.graphFilter, 'chartScreenId')
    },
    customTimeChange () {
      let timeRange = [this.customTime[0].getTime() / 1000, this.customTime[1].getTime() / 1000]
      if (timeRange[0] && timeRange[1]) {
        this.graphFilter.last = ''
        this.graphFilter.start = timeRange[0]
        this.graphFilter.end = timeRange[1]
        this.getGraphData(this.graphFilter, 'chartScreenId')
      } else {
        this.graphFilter.last = '3600'
        this.graphFilter.start = ''
        this.graphFilter.end = ''
        this.getGraphData(this.graphFilter, 'chartScreenId')
      }
    },
    customTimeClear () {
      this.graphFilter.start = ''
      this.graphFilter.end = ''
      this.graphFilter.last = '3600'
      this.getGraphData(this.graphFilter, 'chartScreenId')
    },
    refresh () {
      if (this.formItem.myTemplate) {
        this.drawGraph(this.formItem.myTemplate)
      }
    },
    clickTmp (id) {
      if (this.formItem.myTemplate !== id) {
        this.drawGraph(id)
      }
    },
    // 添加模板
    addTemplateModalOk () {
      this.$refs['addTemplateForm'].validate((valid) => {
        if (valid) {
          this.addTemplateSubmitting = true
          ChangePersonalTmp(this.addTemplateForm).then(res => {
            this.getTmpGroupList()
            this.addTemplateModal = false
            this.addTemplateSubmitting = false
            this.$refs.addTemplateForm.resetFields()
          }).catch(errO => {
            this.addTemplateSubmitting = false
            if (errO.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + errO.request.status,
                desc: errO.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },

    // 模板组
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      }).catch(errO => {
        this.$Notice.error({
          title: '获取用户列表失败！'
        })
      })
    },
    tmpGroupFormReset () {
      this.tmpGroupForm = {
        id: 0,
        name: '',
        top: false,
        default_open: false,
        only_read_user: []
      }
    },
    getTmpGroupList (init = false) {
      getPersonalTmpGroup().then(res => {
        this.tmpGroupError = false
        this.tmpGroupList = res.data
        this.openCollapse()
        if (init) {
          if (this.tmpGroupList.length) {
            if (this.tmpGroupList[0].tmp_group_related.length) {
              this.drawGraph(this.tmpGroupList[0].tmp_group_related[0].id)
            }
          }
        }
      }).catch(errO => {
        this.$Notice.error({
          title: '获取模板组失败！'
        })
        this.tmpGroupList = []
        this.dataError = true
        this.tmpGroupError = true
      })
    },
    openCollapse () {
      let opens = []
      for (let i in this.tmpGroupList) {
        if (this.tmpGroupList[i].default_open) {
          opens.push(this.tmpGroupList[i].id + this.tmpGroupList[i].name)
        }
      }
      this.$nextTick(function () {
        this.tmpGroupCollapse = opens
      })
    },
    tmpGroupSubmit () {
      this.$refs['tmpGroupForm'].validate((valid) => {
        if (valid) {
          this.tmpGroupSubmitting = true
          ChangePersonalTmpGroup(this.tmpGroupForm, this.tmpGroupForm.id).then(res => {
            this.tmpGroupSubmitting = false
            this.getTmpGroupList()
            this.tmpGroupModal = false
            this.tmpGroupFormReset()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(errO => {
            this.tmpGroupSubmitting = false
            if (errO.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + errO.request.status,
                desc: errO.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    tmpGroupDelete (id) {
      deletePersonalTmpGroup(id).then(res => {
        this.$Notice.success({
          title: '操作成功'
        })
        this.getTmpGroupList(true)
      }).catch(errO => {
        if (errO.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + errO.request.status,
            desc: errO.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    tmpGroupToolsClick (name, group) {
      if (this.$store.state.user.userId !== group.user) {
        this.$Notice.warning({
          title: '没有权限！',
          desc: '此模板组属于用户「' + group.user_full_name + '」, 您只有只读权限！'
        })
        return
      }
      switch (name) {
        case 'edit':
          this.tmpGroupForm.id = group.id
          this.tmpGroupForm.name = group.name
          this.tmpGroupForm.top = group.top
          this.tmpGroupForm.default_open = group.default_open
          this.tmpGroupForm.only_read_user = group.only_read_user
          this.tmpGroupModal = true
          break
        case 'add':
          this.addTemplateForm.group = group.id
          this.addTemplateModal = true
          break
        case 'top':
          this.tmpGroupForm.id = group.id
          this.tmpGroupForm.name = group.name
          this.tmpGroupForm.top = true
          this.tmpGroupForm.default_open = group.default_open
          this.tmpGroupForm.only_read_user = group.only_read_user
          this.tmpGroupSubmit()
          break
        case 'cancel_top':
          this.tmpGroupForm.id = group.id
          this.tmpGroupForm.name = group.name
          this.tmpGroupForm.top = false
          this.tmpGroupForm.default_open = group.default_open
          this.tmpGroupForm.only_read_user = group.only_read_user
          this.tmpGroupSubmit()
          break
        case 'merge':
          this.tmpGroupMergeForm.source = group.id
          this.tmpGroupMergeModal = true
          break
        case 'assign':
          this.tmpGroupAssignForm.group = group.id
          this.tmpGroupAssignModal = true
          break
        case 'delete':
          this.$Modal.confirm({
            title: '删除提示',
            content: '确定要删除模板组「' + group.name + '」吗?',
            onOk: () => {
              this.tmpGroupDelete(group.id)
            }
          })
          break
      }
    },
    tmpToolsClick (name, tmp) {
      if (this.$store.state.user.userId !== tmp.user) {
        this.$Notice.warning({
          title: '没有权限！',
          desc: '此模板属于用户「' + tmp.user_full_name + '」, 您只有只读权限！'
        })
        return
      }
      switch (name) {
        case 'edit':
          this.changeMyTemplateModalShow(tmp.id)
          break
        case 'top':
          this.changeMyTemplateForm.id = tmp.id
          this.changeMyTemplateForm.name = tmp.name
          this.changeMyTemplateForm.top = true
          this.changeMyTemplateModalOk()
          break
        case 'cancel_top':
          this.changeMyTemplateForm.id = tmp.id
          this.changeMyTemplateForm.name = tmp.name
          this.changeMyTemplateForm.top = false
          this.changeMyTemplateModalOk()
          break
        case 'move':
          this.moveTmpForm.id = tmp.id
          this.moveTmpCurrentGroup = tmp.group
          this.moveTmpModal = true
          break
        case 'delete':
          this.removeTmp(tmp)
          break
      }
    },
    // 模板组合并
    tmpGroupMergeFormReset () {
      this.tmpGroupMergeForm = {
        source: '',
        target: ''
      }
    },
    tmpGroupMergeSubmit () {
      this.$refs['tmpGroupMergeForm'].validate((valid) => {
        if (valid) {
          this.tmpGroupMergeSubmitting = true
          personalTmpGroupMerge(this.tmpGroupMergeForm).then(res => {
            this.tmpGroupMergeSubmitting = false
            this.getTmpGroupList()
            this.tmpGroupMergeModal = false
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(errO => {
            this.tmpGroupMergeSubmitting = false
            if (errO.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + errO.request.status,
                desc: errO.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    validMergeSourceForm (rule, value, callback) {
      if (!this.tmpGroupMergeForm.source) {
        callback(new Error('请选择源模板组！'))
      } else if (this.tmpGroupMergeForm.source === this.tmpGroupMergeForm.target) {
        callback(new Error('源和目标不能相同！'))
      } else {
        callback()
      }
    },
    validMergeTargetForm (rule, value, callback) {
      if (!this.tmpGroupMergeForm.target) {
        callback(new Error('请选择目标模板组！'))
      } else if (this.tmpGroupMergeForm.source === this.tmpGroupMergeForm.target) {
        callback(new Error('源和目标不能相同！'))
      } else {
        callback()
      }
    },
    // 模板组分发
    tmpGroupAssignFormReset () {
      this.tmpGroupAssignForm = {
        group: '',
        user: ''
      }
    },
    tmpGroupAssignSubmit () {
      this.$refs['tmpGroupAssignForm'].validate((valid) => {
        if (valid) {
          this.tmpGroupAssignSubmitting = true
          personalTmpGroupAssign(this.tmpGroupAssignForm).then(res => {
            this.tmpGroupAssignSubmitting = false
            this.tmpGroupAssignModal = false
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(errO => {
            this.tmpGroupAssignSubmitting = false
            if (errO.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + errO.request.status,
                desc: errO.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 模板移动
    moveTmpSubmit () {
      this.$refs['moveTmpForm'].validate((valid) => {
        if (valid) {
          this.moveTmpSubmitting = true
          ChangePersonalTmp(this.moveTmpForm, this.moveTmpForm.id).then(res => {
            this.moveTmpSubmitting = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.moveTmpModal = false
            this.moveTmpFormReset()
            this.getTmpGroupList()
          }).catch(res => {
            this.moveTmpSubmitting = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    moveTmpFormReset () {
      this.$refs.moveTmpForm.resetFields()
    }
  }
}
</script>

<style>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
  #monitor_card .ivu-card-body {
    padding: 0;
  }
  #monitor_card .ivu-card-head {
    background-color: #F2F2F2;
    height: 30px;
    padding:0;
  }
  #monitor_card .ivu-card-head p {
    padding-left: 10px;
    height: 30px;
    line-height: 30px;
    text-align:center;
  }
  #tmp-group-collapse .ivu-collapse-content-box, #tmp-group-collapse .ivu-collapse-content {
    padding: 0;
  }
  #tmp-group-collapse .tmp-item {
    padding: 0 16px;
    line-height: 30px;
    display: block;
    color: #515a6e;
    height: 30px;
  }
  #tmp-group-collapse .tmp-item-active {
    background-color: rgb(243, 243, 243);
  }
  #tmp-group-collapse .tmp-item:hover {
    background-color: rgb(243, 243, 243);
  }
  #tmp-group-collapse .tmp-item:visited {
    background-color: rgb(243, 243, 243);
  }
  .cu-content {
    padding: 0;
    overflow-y: auto;
    max-height: 250px;
    padding-bottom: 5px;
  }
  .cu-content::-webkit-scrollbar {
    width: 5px;
  }
  .cu-content::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .cu-content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
<style lang="less">
@media screen and (max-width:640px){
  .templates{
    .ivu-layout-sider{
      width:100%!important;
      max-width:100%!important;
    }
    .ivu-layout.ivu-layout-has-sider{
      flex-direction: column;
    }
    .svg-inline--fa{
      display: none;
    }
    .ivu-select{
      width:59%!important;
    }
    .ivu-col-span-23{
      width:100%!important;
    }
  }
}
</style>
